import type { LoaderFunctionArgs } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ params }: LoaderFunctionArgs) {
  const countryCode = params?.countryCode ?? "US";

  return json({ countryCode });
}

export default function TermsAndConditionsForCountryCode() {
  const { countryCode } = useLoaderData<typeof loader>();

  return (
    <div className={"rounded bg-gray-700 p-4 text-white"}>
      <h3 className={"mb-4 text-center text-xl font-bold"}>
        General Terms and Conditions
      </h3>
      <p>
        Welcome to 7qz, a social betting site where you can participate in daily
        and weekly contests for free and also real money prizes. These Terms of
        Service (the &quot;Agreement&quot;) govern your access to and use of the
        7qz website, mobile applications, and other online products and services
        provided by{" "}
        <span>{countryCode === "ZA" ? "7qz PTY LTD" : "J50 VENTURES LLC"}</span>{" "}
        DBA 7QZ HENCEFORTH 7QZ, LLC (collectively, the &ldquo;Services&quot;).
        <br />
        <br />
        &rdquo;7Qz&rdquo; means
        <br />
        <span>{`${
          countryCode === "ZA" ? "7qz PTY LTD" : "J50 VENTURES LLC"
        }`}</span>
        <br />
        <span>{`${
          countryCode === "ZA" ? "3 Loquat Place" : "468 N CAMDEN DRIVE"
        }`}</span>
        <br />
        <span>{`${
          countryCode === "ZA"
            ? "Constantia, Cape Town"
            : "BEVERLY HILLS, CA 90210 USA"
        }`}</span>
        <br />
        Email:&nbsp;
        <a href="mailto:administration@7qz.io" target="_blank" rel="noreferrer">
          administration@7qz.io
          <br />
          <br />
          &zwj;
        </a>
        <strong>
          BY ACCESSING OR USING THE SERVICES, YOU AGREE TO BE BOUND BY THESE
          TERMS OF SERVICE AND THE 7QZ PRIVACY POLICY, WHICH IS INCORPORATED
          HEREIN BY REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT
          USE THE SERVICES.
          <br />
          <br />
          ELIGIBILITY
        </strong>
        <br />
        To use the Services, you must be at least 18 years old and located
        within the United States or Canada. You may not use the Services if you
        are located in a state or province where participation in daily fantasy
        sports contests is prohibited by law. Employees and family members of
        7qz, its affiliates, and partners are not eligible to participate in
        contests on the Services.
        <br />
        <br />
        <strong>REGISTRATION</strong>
        <br />
        To participate in contests on the Services, you must create an account
        and provide accurate and complete information, including your name,
        email address, date of birth, and location. You may be required to
        provide additional information to verify your identity. You are
        responsible for maintaining the confidentiality of your account login
        information, and you are solely responsible for all activities that
        occur under your account. You may not transfer or share your account
        with anyone.
        <br />
        <br />
        <strong>CONTESTS</strong>
        <br />
        7qz offers a variety of daily and weekly fantasy/game of skill sports
        contests for various professional sports leagues. Contest entry fees and
        prize amounts vary by contest.
        <br />
        <br />
        Contest results and prize calculations are based on the final statistics
        and scoring results at the completion of the last professional sports
        game of each individual Contest. Once Contest results are reviewed and
        graded, prizes are awarded. The scoring results of a Contest will not be
        changed regardless of any official statistics or scoring adjustments
        made by the leagues at later times or dates, except in 7qz&#39;s sole
        discretion.
        <br />
        <br />
        Contests may be cancelled, postponed, or rescheduled due to unforeseen
        circumstances, including but not limited to inclement weather, player
        injuries, and league scheduling changes. Information about the effects
        of a cancellation, postponement, or rescheduling of a game within a
        Contest is available in the &quot;Rules &amp; Scoring&quot; tab of each
        Contest.
        <br />
        <br />
        <strong>PAYMENTS AND WITHDRAWALS</strong>
        <br />
        To participate in contests on the Services, you must deposit funds into
        your account using a valid credit or debit card, PayPal, or other
        approved payment method.
        <br />
        <br />
        Prize money won in contests will be credited to your account balance,
        and you may request a withdrawal of your account balance at any time.
        Withdrawals may be subject to a processing fee and may take up to 10
        business days to process.
        <br />
        <br />
        <strong>CONDUCT</strong>
        <br />
        You agree to use the Services in accordance with these Terms of Service
        and all applicable laws and regulations. You may not use the Services
        for any unlawful purpose, to promote or engage in illegal activities, or
        to harass, intimidate, or harm any other user.
        <br />
        <br />
        7qz reserves the right to terminate or suspend your account and access
        to the Services at any time, for any reason or no reason, including but
        not limited to violations of these Terms of Service, fraud, or
        suspicious or illegal activity.
        <br />
        <br />
        <strong>INTELLECTUAL PROPERTY</strong>
        <br />
        The Services and all content and materials contained therein, including
        but not limited to text, graphics, logos, images, and software, are
        owned or licensed by 7qz and are protected by United States and
        international copyright, trademark, and other intellectual property
        laws.
        <br />
        <br />
        You may not reproduce, distribute, modify, or create derivative works of
        any content
        <br />
        <br />
        We reserve the right to modify, update, or remove any portion of these
        Terms of Service or our Privacy Policy at any time, with or without
        notice. Your continued use of the 7qz website and services after any
        modifications to these policies constitutes your acceptance of the
        revised policies. If you do not agree to any of the terms or policies
        set forth herein, please do not use the 7qz website or services.
        <br />
        <br />
        <strong>USE OF DATA</strong>
        <br />
        We collect and use data in accordance with our Privacy Policy, which is
        incorporated into these Terms of Service by reference.
        <br />
        <br />
        <strong>TERMINATION</strong>
        <br />
        We may terminate your access to and use of the Service, at our sole
        discretion, at any time and without notice to you. Upon termination, all
        licenses and other rights granted to you in these Terms of Service will
        immediately cease.
        <br />
        <br />
        <strong>
          LIMITATION OF LIABILITY
          <br />
          &zwj;
        </strong>
        You agree that we will not be liable for any damages, including but not
        limited to direct, indirect, incidental, punitive, and consequential
        damages, arising out of or in connection with your use or inability to
        use the Service or any content, even if we have been advised of the
        possibility of such damages. In no event will our total liability to you
        for all damages, losses, or causes of action exceed the amount paid by
        you to us, if any, for accessing or using the Service.
        <br />
        <br />
        <strong>INDEMNIFICATION</strong>
        <br />
        You agree to indemnify and hold us harmless from and against any and all
        claims, liabilities, damages, losses, costs, expenses, fees of any kind
        (including reasonable attorneys&#39; fees and legal costs), arising from
        or relating to your use of the Service or any content, your violation of
        these Terms of Service, or your violation of any rights of another.
        <br />
        <br />
        <strong>DISPUTE RESOLUTION</strong>
        <br />
        Any dispute arising out of or in connection with these Terms of Service
        or the Service will be resolved in accordance with the arbitration rules
        of the American Arbitration Association. The arbitration will take place
        in the United States and will be conducted in English. The
        arbitrator&#39;s decision will be final and binding on all parties. You
        agree to waive any right to a trial by jury in any matter arising out of
        or relating to these Terms of Service or the Service.
        <br />
        <br />
        <strong>
          GOVERNING LAW AND VENUE
          <br />
          &zwj;
        </strong>
        These Terms of Service and your use of the Services will be governed by
        and construed in accordance with the laws of the State of Delaware,
        without giving effect to any principles of conflicts of law. You agree
        that any action arising out of or in connection with these Terms of
        Service or the Services will be brought only in a federal or state court
        located in the State of Delaware, and you hereby consent to the personal
        jurisdiction and venue of such courts.
        <br />
        <br />
        <strong>
          GENERAL TERMS
          <br />
          &zwj;
        </strong>
        These Terms of Service, together with the Privacy Policy, constitute the
        entire agreement between you and 7qz with respect to your use of the
        Services. If any provision of these Terms of Service is held to be
        invalid or unenforceable, such provision shall be struck and the
        remaining provisions shall be enforced. 7qz&#39;s failure to enforce any
        right or provision in these Terms of Service shall not constitute a
        waiver of such right or provision unless acknowledged and agreed to by
        7qz in writing.
        <br />
        <br />
        <strong>
          CONTACT US
          <br />
          &zwj;
        </strong>
        If you have any questions about these Terms of Service, please contact
        us at&nbsp;
        <a href="mailto:support@7qz.com" target="_blank" rel="noreferrer">
          support@7qz.com
        </a>
      </p>

      <h3>
        <strong>2 - Anti-Money Laundering</strong>
      </h3>

      <p>
        At 7Qz, we take anti-money laundering (AML) laws and regulations very
        seriously. Our AML policies and procedures are designed to prevent our
        platform from being used for any illegal activities such as money
        laundering or terrorist financing.
        <br />
        <br />
        <strong>MEASURES IMPLEMENTED</strong>
        <strong>&nbsp;</strong>- We have implemented a number of measures to
        detect and prevent any suspicious transactions that may occur on our
        platform. This includes customer due diligence procedures, ongoing
        monitoring of customer accounts, and reporting of suspicious
        transactions to relevant authorities.
        <br />
        <br />
        <strong>CUSTOMER INFORMATION</strong>
        <strong>&nbsp;</strong>- We require all customers to provide accurate
        and up-to-date identification and contact information upon registration,
        and we may request additional documentation or information to verify
        their identity or the source of their funds. We reserve the right to
        refuse or block any transactions that we believe may be suspicious or
        linked to illegal activities.
      </p>
    </div>
  );
}
